import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BaseFormControl } from '../../base/base-form-control.directive';

@Component({
    selector: 'app-text-input',
    standalone: true,
    templateUrl: './text-input.component.html',
    styleUrl: './text-input.component.scss',
    imports: [CommonModule]
})
export class TextInputComponent extends BaseFormControl<string> { }
